import React, { useRef, useEffect, useContext, createContext, useState, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { IconButton, CircularProgress, FormControl, InputLabel, MenuItem, FormHelperText, TextField as TextField$1, InputAdornment as InputAdornment$1, Dialog as Dialog$1, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CancelTwoToneIcon from '@mui/icons-material/CancelTwoTone';
import { initReactI18next, I18nextProvider, useTranslation } from 'react-i18next';
import i18n from 'i18next';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton$1 from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import { useForm, useWatch, Controller, useFieldArray } from 'react-hook-form';
import Button from '@mui/material/Button';
import { validateOrShowMultipleErrors, validateHasAtLeastOneSymbol, validateDoesNotContainSpecialSymbols, validateOrShowError, getValueFromObject } from '@wave/utils';
import Select from '@mui/material/Select';
import Autocomplete from '@mui/material/Autocomplete';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
export { default as ImageIcon } from '@mui/icons-material/InsertPhoto';
import DateTimePicker from '@mui/lab/DateTimePicker';
import AdapterDayjs from '@mui/lab/AdapterDayjs';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import tz from 'dayjs/plugin/timezone';
import { createTheme, StyledEngineProvider, ThemeProvider, styled } from '@mui/material/styles';
import StylesProvider from '@mui/styles/StylesProvider';
import '@fontsource/source-sans-pro/400.css';
import '@fontsource/source-sans-pro/700.css';
import '@wave/common/lib/styles/index.scss';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { DataGrid, GridToolbar, elGR, GridToolbarContainer, GridToolbarFilterButton, GridToolbarDensitySelector, GridToolbarExport } from '@mui/x-data-grid';
export { default as AddIcon } from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
export { default as DeleteIcon } from '@mui/icons-material/Delete';
import Table$1 from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableBodyMaterial from '@mui/material/TableBody';
import TableHeadMaterial from '@mui/material/TableHead';
import TableRowMaterial from '@mui/material/TableRow';
import TableCellMaterial from '@mui/material/TableCell';
export { default as ExitToAppIcon } from '@mui/icons-material/ExitToApp';
export { default as LockIcon } from '@mui/icons-material/Lock';
export { default as PersonIcon } from '@mui/icons-material/Person';
import InfoIcon from '@mui/icons-material/Info';
export { default as InfoIcon } from '@mui/icons-material/Info';
export { default as CouponIcon } from '@mui/icons-material/LocalOfferRounded';
import Menu from '@mui/material/Menu';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
export { default as ContestsIcon } from '@mui/icons-material/EmojiEventsRounded';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
export { default as EditIcon } from '@mui/icons-material/Create';
export { default as ViewDetailsIcon } from '@mui/icons-material/CallMade';
export { default as PeopleIcon } from '@mui/icons-material/People';
export { default as SearchIcon } from '@mui/icons-material/Search';
export { default as GamesIcon } from '@mui/icons-material/SportsEsportsRounded';
export { default as ExpiredIcon } from '@mui/icons-material/TimerOff';
export { default as RedeemIcon } from '@mui/icons-material/Redeem';
export { default as BlockIcon } from '@mui/icons-material/Block';
export { default as WinnersIcon } from '@mui/icons-material/EmojiPeople';
export { default as RunnersIcon } from '@mui/icons-material/DirectionsRun';
export { default as UploadIcon } from '@mui/icons-material/FileUpload';
export { default as HelpIcon } from '@mui/icons-material/HelpOutline';
export { default as FavoriteIcon } from '@mui/icons-material/Favorite';
export { default as ExploreIcon } from '@mui/icons-material/Explore';
export { default as DownloadIcon } from '@mui/icons-material/GetApp';
export { default as SettingsIcon } from '@mui/icons-material/Settings';
export { default as PendingIcon } from '@mui/icons-material/Update';

var styles$r = {"section":"Widget-module_section_1ig6a"};

/**
 * Widget is a UI container that groups info or settings. By default its a flexbox container and its content is aligned center.
 */

const Widget = ({
  children,
  backgroundColor,
  color = '#ffffff',
  padding = '32px',
  className = ''
}) => {
  const style = {
    backgroundColor,
    padding,
    color
  };
  return /*#__PURE__*/React.createElement("section", {
    className: `${styles$r.section} ${className}`,
    style: style
  }, children);
};

Widget.propTypes = {
  /**
   * The content of the Widget
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),

  /**
   * Sets the background color of the widget
   */
  backgroundColor: PropTypes.string,

  /**
   * Sets content's type color
   */
  color: PropTypes.string,

  /**
   * Sets the widget's padding around the content
   */
  padding: PropTypes.string,

  /**
   * A className that will added to widget for extra styling
   */
  className: PropTypes.string
};

var styles$q = {"title":"PageTitle-module_title_KT0fr"};

/**
 * A page title component
 */

const PageTitle = ({
  title,
  color
}) => {
  return /*#__PURE__*/React.createElement("h1", {
    className: styles$q.title,
    style: {
      color
    }
  }, title);
};

PageTitle.propTypes = {
  /**
   * Sets the content of the title
   */
  title: PropTypes.string,

  /**
   * Sets the title's color
   */
  color: PropTypes.string
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var styles$p = {"container":"MessageBox-module_container_1sWqQ"};

/**
 * A box element than can contain text or other elements.
 */

const MessageBox = ({
  show = true,
  className,
  color = '#ffffff',
  backgroundColor = '#36495e',
  padding = '1rem',
  children,
  ...rest
}) => {
  if (!show) return null;
  return /*#__PURE__*/React.createElement("section", _extends({
    className: `${styles$p.container} ${className}`,
    style: {
      backgroundColor,
      color,
      padding
    }
  }, rest), children);
};

MessageBox.propTypes = {
  /**
   * Controls wether the box element is visible
   */
  show: PropTypes.bool,

  /**
   * Passes a string of classes applied on the element's section container
   */
  className: PropTypes.string,

  /**
   * Sets the box element's background color
   */
  backgroundColor: PropTypes.string,

  /**
   * Sets the color of the text's font
   */
  color: PropTypes.string,

  /**
   * Sets the padding of the box element
   */
  padding: PropTypes.string,

  /**
   * The content of the box element
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

var styles$o = {"container":"ErrorBox-module_container_3bmj6","closeIcon":"ErrorBox-module_closeIcon_xUht-","errorMessageContainer":"ErrorBox-module_errorMessageContainer_3tydC"};

/**
 * A box element for displaying errors. The screen scroll it in display when it appears.
 */

const ErrorBox = ({
  showError = false,
  children,
  backgroundColor = '#36495e',
  color = '#ffffff',
  padding = '1rem',
  className,
  errorIconClassName,
  onClose,
  errorIconColor = '#ffffff',
  closeIconColor = '#ffffff',
  ...rest
}) => {
  const errorMessageRef = useRef();
  useEffect(() => {
    if (errorMessageRef.current) {
      errorMessageRef.current.scrollIntoView();
    }
  }, [showError]);
  return /*#__PURE__*/React.createElement("div", {
    ref: errorMessageRef
  }, /*#__PURE__*/React.createElement(MessageBox, _extends({
    show: showError,
    backgroundColor: backgroundColor,
    padding: padding,
    className: `${styles$o.container} ${className}`
  }, rest), /*#__PURE__*/React.createElement(CancelTwoToneIcon, {
    className: errorIconClassName,
    style: {
      color: errorIconColor
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$o.errorMessageContainer,
    style: {
      color
    }
  }, children), /*#__PURE__*/React.createElement(IconButton, {
    className: styles$o.closeIcon,
    "aria-label": "close",
    disableRipple: true,
    disableFocusRipple: true,
    onClick: onClose,
    size: "large",
    style: {
      padding: 0
    }
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    style: {
      color: closeIconColor
    }
  }))));
};

ErrorBox.propTypes = {
  /**
   * Controls wether the box element is visible
   */
  showError: PropTypes.bool,

  /**
   * Sets the box element's background color
   */
  backgroundColor: PropTypes.string,

  /**
   * Sets content and closeIcon color
   */
  color: PropTypes.string,

  /**
   * Sets the padding of the box element
   */
  padding: PropTypes.string,

  /**
   * Pass a string of classes applied on the box element
   */
  className: PropTypes.string,

  /**
   * Pass a string of classes applied on the element's left cancel icon
   */
  errorIconClassName: PropTypes.string,

  /**
   * The content of the box element
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),

  /**
   * A callback that triggers when close icon is clicked
   */
  onClose: PropTypes.func,

  /**
   * Sets the box element's left icon color
   */
  closeIconColor: PropTypes.string,

  /**
   * Sets the error icon color
   */
  errorIconColor: PropTypes.string
};

var submit$1 = "Submit";
var errors$1 = {
	genericTitle: "Something went wrong!",
	genericMessage: "There was an error. Please retry later.",
	required: "This field is required.",
	email: "Please enter a valid e-mail address.",
	minLength: "The number you typed is less than 8 digits..",
	maxLength: "The number you typed is greater than 8 digits.",
	telephone: "The phone number is not valid.",
	"confirm-password": "The password must be the same in both fields.",
	"confirm-password-rules": {
		"1": "The password must contain at least one of the symbols: !#$%^&*()+[]{}?:.",
		"2": "The password must not contain any of the symbols: <>~?' "
	},
	maxLengthNumber: "The password can be {{max}} characters long.",
	minLengthNumber: "The password has to be at least {{min}} characters long.",
	maxNumber: "It has to be up to {{max}}",
	minNumber: "It has to be at least {{min}}",
	"both-values-required": "Date range is required.",
	"date-required": "Date selection is required.",
	isNotNumber: "This field must be a number.",
	exactLengthNumber: "This field must have exactly {{number}} digits.",
	dateInvalid: "The date is invalid",
	minDateError: "The date exceeds the maximum permissible date",
	maxDateError: "The date is before the minimum permissible date",
	"confirm-prefix-rules": "The prefix must not contain the following characters: $<>@#^[]{}?:;|'\"\\,~'=.",
	noImage: "No image chosen",
	noRows: "There are no data yet!",
	minDate: "The date has to be after {{date}}",
	maxDate: "The date has to be before {{date}}"
};
var yes$1 = "Yes";
var no$1 = "No";
var ok$1 = "OK";
var retry$1 = "Retry";
var confirm$1 = {
	header: "Confirm Action",
	body: "Are you sure you want to proceed with this action?"
};
var gridLabels$1 = {
	toolbarFilters: "Φίλτρα/ Αναζήτηση",
	toolbarDensity: "Πυκνότητα Εμφάνισης",
	toolbarDensityCompact: "Συμπαγής",
	toolbarDensityStandard: "Κανονική",
	toolbarDensityComfortable: "Άνετη"
};
var enTranslation = {
	submit: submit$1,
	errors: errors$1,
	yes: yes$1,
	no: no$1,
	ok: ok$1,
	retry: retry$1,
	confirm: confirm$1,
	gridLabels: gridLabels$1
};

var submit = "Υποβολή";
var errors = {
	required: "Αυτό το πεδίο είναι υποχρεωτικό.",
	email: "Παρακαλώ πληκτρολογήστε μία έγκυρη διεύθυνση e-mail.",
	minLength: "Ο αριθμός που πληκρολογήσατε είναι μικρότερος των 8 ψηφίων.",
	maxLength: "Ο αριθμός που πληκρολογήσατε είναι μεγαλύτερος των 8 ψηφίων.",
	telephone: "Ο αριθμός τηλεφώνου δεν είναι έγκυρος.",
	"confirm-password": "Ο κωδικός πρέπει να είναι ίδιος και στα δύο πεδία.",
	"confirm-password-rules": {
		"1": "O κωδικός πρέπει να περιέχει έστω ένα από τα σύμβολα: !#$%^&*()+[]{}?:.",
		"2": "O κωδικός δεν πρέπει να περιέχει κανένα από τα σύμβολα: <>~;` "
	},
	maxLengthNumber: "Το password μπορεί να έχει έως {{max}} ψηφία.",
	minLengthNumber: "Το password πρέπει να έχει περισσότερα από {{min}} ψηφία.",
	maxNumber: "Πρέπει να είναι έως {{max}}",
	minNumber: "Πρέπει να είναι τουλάχιστον {{min}}",
	"both-values-required": "Η επιλογή εύρους ημερομηνιών είναι υποχρεωτική.",
	"date-required": "Η επιλογή ημερομηνίας είναι υποχρεωτική.",
	isNotNumber: "Το πεδίο αυτό πρέπει να είναι αριθμός.",
	exactLengthNumber: "Το πεδίο αυτό πρέπει να έχει ακριβώς {{number}} ψηφία.",
	dateInvalid: "Η ημερομηνία δεν είναι έγκυρη",
	minDateError: "Η ημερομηνία ξεπερνά τη μέγιστη επιτρεπτή ημερομηνία",
	maxDateError: "Η ημερομηνία είναι πριν την ελάχιστη επιτρεπτή ημερομηνία",
	"confirm-prefix-rules": "Το πρόθεμα δεν πρέπει να περιέχει τους ακόλουθους χαρακτήρες: $<>@#^[]{}?:;|'\"\\,~`=.",
	noImage: "Δεν έχει επιλεχθεί κάποια εικόνα",
	minDate: "H ημερομηνία πρέπει να είναι μετά από τις {{date}}",
	maxDate: "H ημερομηνία πρέπει να είναι πριν από τις {{date}}",
	noRows: "Δεν υπάρχουν δεδομένα ακόμα."
};
var yes = "Ναι";
var no = "Όχι";
var ok = "OK";
var retry = "Προσπάθησε ξανά";
var confirm = {
	header: "Eπιβεβαίωση ενέργειας",
	body: "Είσαι σίγουρος ότι θέλεις να κάνεις αυτή την ενέργεια"
};
var gridLabels = {
	toolbarFilters: "Φίλτρα/ Αναζήτηση",
	toolbarDensity: "Πυκνότητα Εμφάνισης",
	toolbarDensityCompact: "Συμπαγής",
	toolbarDensityStandard: "Κανονική",
	toolbarDensityComfortable: "Άνετη"
};
var elTranslation = {
	submit: submit,
	errors: errors,
	yes: yes,
	no: no,
	ok: ok,
	retry: retry,
	confirm: confirm,
	gridLabels: gridLabels
};

const i18Instance = i18n.use(initReactI18next);
i18Instance.init({
  react: {
    useSuspense: false
  },
  debug: false,
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false // not needed for react as it escapes by default

  },
  resources: {
    en: {
      components: enTranslation
    },
    el: {
      components: elTranslation
    }
  }
}, error => {
  if (error) return console.log(error);
});

const TranslationProvider = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(I18nextProvider, {
    i18n: i18Instance
  }, children);
};

TranslationProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

var styles$n = {"textfield":"Inputs-module_textfield_1vdP3","description":"Inputs-module_description_32vOn"};

const StandardInput = ({
  errorMessage = '',
  label = '',
  endAdornment = null,
  readOnly = false,
  disabled = false,
  maxLength = null,
  fullWidth = true,
  textfieldClassname,
  description,
  descriptionClassname,
  autoComplete = 'on',
  inputRef = {},
  ...restProps
}) => {
  const InputLabelProps = restProps !== null && restProps !== void 0 && restProps.current ? {
    shrink: true
  } : {};
  return /*#__PURE__*/React.createElement(React.Fragment, null, description && /*#__PURE__*/React.createElement("p", {
    className: `${styles$n.description} ${descriptionClassname || ''}`
  }, description), /*#__PURE__*/React.createElement(TextField, _extends({}, inputRef, {
    InputLabelProps: InputLabelProps,
    label: label,
    helperText: errorMessage,
    autoComplete: autoComplete,
    variant: "standard",
    fullWidth: true,
    className: `${!description ? styles$n.textfield : ''} ${textfieldClassname || ''}`,
    InputProps: {
      endAdornment: endAdornment,
      readOnly: readOnly,
      disabled: disabled
    },
    inputProps: {
      maxLength: 400
    },
    disabled: disabled
  }, restProps)));
};

StandardInput.propTypes = {
  /**
   * Sets the text for the error message of the input
   */
  errorMessage: PropTypes.string,

  /**
   * Sets the text for the label of the input
   */
  label: PropTypes.string,

  /**
   * accepts an element than goed to the end of the input (ex. and icon)
   */
  endAdornment: PropTypes.element,

  /**
   * Controls if the input is readonly
   */
  readOnly: PropTypes.bool,

  /**
   * Controls id the input is disabled
   */
  disabled: PropTypes.bool,

  /**
   * Sets the max number of character the user can type
   */
  maxLength: PropTypes.number,

  /**
   * Property that sets if the input claims the whole width of its container
   */
  fullWidth: PropTypes.bool,

  /**
   * Accepts a className that gets applied to the material TextField component
   */
  textfieldClassname: PropTypes.string,

  /**
   * A description added at the top of the TextField component
   */
  description: PropTypes.string,

  /**
   * Accepts extra classes for the description's element
   */
  descriptionClassname: PropTypes.string,

  /**
   * 	This prop helps users to fill forms faster, especially on mobile devices. The name can be confusing, as it's more like an autofill. You can learn more about it following the specification. https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: PropTypes.string,

  /**
   * Used to pass a ref callback to the native input component.
   */
  inputRef: PropTypes.object
};

const useLanguage = language => {
  const {
    i18n
  } = useTranslation();
  useEffect(() => {
    if (language !== i18n.language) {
      i18n.changeLanguage(language);
    }
  });
};

const emailRegexPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const EmailInput = ({
  control,
  errors = {},
  label,
  name = 'email',
  required = true,
  requiredErrorMessage,
  invalidEmailMessage,
  autoComplete = 'on',
  lang,
  ...rest
}) => {
  var _errors$name;

  useLanguage(lang);
  const {
    t,
    ready
  } = useTranslation(['components']);
  const baseName = 'components:errors';
  const inputRef = control !== null && control !== void 0 && control.register ? { ...control.register(name, {
      required: {
        value: required,
        message: requiredErrorMessage ? requiredErrorMessage : ready ? t(`${baseName}.required`) : ''
      },
      pattern: {
        value: emailRegexPattern,
        message: invalidEmailMessage ? invalidEmailMessage : ready ? t(`${baseName}.email`) : ''
      }
    })
  } : {};
  return /*#__PURE__*/React.createElement(StandardInput, _extends({
    inputRef: inputRef,
    label: label,
    autoComplete: autoComplete,
    type: "email",
    errorMessage: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
    error: !!errors[name]
  }, rest));
};

EmailInput.propTypes = {
  register: PropTypes.func,

  /**
   * A property that provides the React Hook Form errors object to retrieve errors
   */
  errors: PropTypes.object,

  /**
   * Sets the input's label text
   */
  label: PropTypes.string,

  /**
   * A property used to set the input element's name
   */
  name: PropTypes.string,

  /**
   * 	Sets if the input should be required for the submission of the form
   */
  required: PropTypes.bool,

  /**
   * 	This prop helps users to fill forms faster, especially on mobile devices. The name can be confusing, as it's more like an autofill. You can learn more about it following the specification. https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: PropTypes.string,

  /**
   * A property to set a specific error message (required check), ignoring the one provided from the errors object of react-hook-forms
   */
  requiredErrorMessage: PropTypes.string,

  /**
   * A property to set a specific error message ("is Email" check), ignoring the one provided from the errors object of react-hook-forms
   */
  invalidEmailMessage: PropTypes.string,

  /**
   * Sets the default language of the error messages
   */
  lang: PropTypes.string
};

/**
 * A component used as an end adornment for password inputs
 */

const PasswordEndAdornment = ({
  setShowPassword,
  showPassword
}) => {
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };

  return /*#__PURE__*/React.createElement(InputAdornment, {
    position: "end"
  }, /*#__PURE__*/React.createElement(IconButton$1, {
    "aria-label": "toggle password visibility",
    onClick: handleClickShowPassword,
    onMouseDown: handleMouseDownPassword,
    size: "large"
  }, showPassword ? /*#__PURE__*/React.createElement(VisibilityOff, null) : /*#__PURE__*/React.createElement(Visibility, null)));
};

PasswordEndAdornment.propTypes = {
  /**
   * A parameter passing a function than when called should set the value of the showPassword property
   */
  setShowPassword: PropTypes.func,

  /**
   * Controls if the adornment's icon is repressenting an input with a visible password or not
   */
  showPassword: PropTypes.bool
};

const PasswordInput = ({
  control,
  errors,
  name = 'password',
  label,
  requiredErrorMessage,
  lang,
  ...rest
}) => {
  var _errors$name;

  useLanguage(lang);
  const {
    t,
    ready
  } = useTranslation(['components']);
  const baseName = 'components:errors';
  const [showPassword, setShowPassword] = React.useState(false);
  const inputRef = control !== null && control !== void 0 && control.register ? { ...(control === null || control === void 0 ? void 0 : control.register(name, {
      required: {
        value: true,
        message: requiredErrorMessage ? requiredErrorMessage : ready ? t(`${baseName}.required`) : ''
      }
    }))
  } : '';
  return /*#__PURE__*/React.createElement(StandardInput, _extends({
    inputRef: inputRef,
    label: label,
    type: showPassword ? 'text' : 'password',
    errorMessage: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
    error: !!errors[name],
    endAdornment: /*#__PURE__*/React.createElement(PasswordEndAdornment, {
      showPassword: showPassword,
      setShowPassword: setShowPassword
    })
  }, rest));
};

PasswordInput.propTypes = {
  register: PropTypes.func,

  /**
   * A property that provides the React Hook Form errors object to retrieve errors
   */
  errors: PropTypes.object,

  /**
   * A property used to set the input element's name
   */
  name: PropTypes.string,

  /**
   * Sets the input's label text
   */
  label: PropTypes.string,

  /**
   * A property to set a specific error message, ignoring the one provided from the errors object of react-hook-forms
   */
  requiredErrorMessage: PropTypes.string,

  /**
   * Sets the default language of the error messages
   */
  lang: PropTypes.string
};

function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

const FormContext = /*#__PURE__*/createContext();
const states = {
  pending: 'pending',
  disabled: 'disabled',
  error: 'error',
  success: 'success'
};
const {
  pending,
  disabled,
  error,
  success
} = states;
/**
 * A component configured to function as part of the Form component, providing context to Form's children. Exported context can be used with useForm hook. Context includes many similar functionalities with react-hook-form:
 *  
    state: form's state ['pending','disabled', 'error', 'success'],
    register,
    control,
    reset,
    watch,
    errors,
    setValue,
    getValues,
    isSubmitting,
    isDirty,
    dirtyFields,
    isDisabled,
    hasError,
    errorTitle,
    errorMessage,
    disableForm,
    resetState,
    onSubmit,
    trigger,
    defaultValues,
    showSuccess,
    unregister,
 */

const FormContextProvider = ({
  submitCallback,
  defaultValues,
  children
}) => {
  const {
    register,
    handleSubmit,
    watch,
    control,
    reset,
    setValue,
    getValues,
    trigger,
    unregister,
    formState: {
      errors,
      isSubmitting,
      isDirty,
      dirtyFields
    }
  } = useForm({
    defaultValues,
    reValidateMode: 'onChange'
  });
  const [state, setState] = useState(pending);
  const [errorMessage, setErrorMessage] = useState(null);
  const [errorTitle, setErrorTitle] = useState(null);

  if (defaultValues) {
    Object.keys(defaultValues).forEach(value => {
      if (typeof defaultValues[value] === 'number') {
        defaultValues[value] = String(defaultValues[value]);
      }
    });
  } //Resets Form when default values Come from an Api


  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);
  const onSubmit = handleSubmit(function (data) {
    try {
      setState(pending);

      const _temp = _catch(function () {
        return Promise.resolve(submitCallback(data)).then(function () {
          setState(success);
        });
      }, function (err) {
        setErrorTitle(err === null || err === void 0 ? void 0 : err.userTitle);
        setErrorMessage(err === null || err === void 0 ? void 0 : err.userMessage);
        setState(error);
      });

      return Promise.resolve(_temp && _temp.then ? _temp.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  });

  const resetState = () => {
    setState(pending);
  };

  const disableForm = () => {
    setState(disabled);
  };

  const hasError = state === error;
  const isDisabled = state === disabled;
  const showSuccess = state === success;
  const enhancedChildren = Children.map(children, child => {
    if (typeof child.type === 'string') {
      return child;
    }

    return /*#__PURE__*/cloneElement(child, {
      onSubmit
    });
  });
  return /*#__PURE__*/React.createElement(FormContext.Provider, {
    value: {
      useForm,
      state,
      register,
      control,
      reset,
      watch,
      errors,
      setValue,
      getValues,
      isSubmitting,
      isDirty,
      dirtyFields,
      isDisabled,
      hasError,
      errorTitle,
      errorMessage,
      disableForm,
      resetState,
      onSubmit,
      trigger,
      defaultValues,
      showSuccess,
      unregister
    }
  }, enhancedChildren);
};
FormContextProvider.propTypes = {
  /**
   * Sets the callback that is called on form submit event
   */
  submitCallback: PropTypes.func.isRequired,

  /**
   * An object with the form default values. Default values can be a promise form API
   */
  defaultValues: PropTypes.object,

  /**
   * The Form and form's content
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};
const useFormContext = () => {
  const context = useContext(FormContext);

  if (!context) {
    throw new Error(`useFormContext must be used inside a Form component`);
  }

  return context;
};

var styles$m = {"wrapper":"InnerLoader-module_wrapper_gihmk","progress":"InnerLoader-module_progress_1qmz7","iconWrapper":"InnerLoader-module_iconWrapper_394YV"};

/**
 * A loader for use inside other components
 */

const InnerLoader = ({
  loading,
  children,
  color = '#ffffff',
  size = 24,
  className,
  ...rest
}) => {
  const progressStyles = {
    color: color
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles$m.wrapper} ${className}`
  }, children, loading ? /*#__PURE__*/React.createElement("div", {
    className: styles$m.iconWrapper
  }, /*#__PURE__*/React.createElement(CircularProgress, _extends({
    size: size,
    style: progressStyles
  }, rest))) : null);
};

InnerLoader.propTypes = {
  /**
   * Set's the loader state
   */
  loading: PropTypes.bool.isRequired,

  /**
   * Sets components or text before the loader
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),

  /**
   * Sets loader's color
   */
  color: PropTypes.string,

  /**
   * Sets loader's size
   */
  size: PropTypes.number,

  /**
   * Sets className to loaders container
   */
  className: PropTypes.string
};

var styles$l = {"semitransparent":"Buttons-module_semitransparent_-Cmlf","emptyButton":"Buttons-module_emptyButton_1j3vJ"};

const PrimaryButton = props => {
  return /*#__PURE__*/React.createElement(Button, _extends({
    variant: "contained"
  }, props), props.children);
};

const SecondaryButton = props => {
  return /*#__PURE__*/React.createElement(Button, _extends({
    variant: "outlined"
  }, props), props.children);
};

const TextButton = props => {
  return /*#__PURE__*/React.createElement(Button, props, props.children);
};

const PrimaryButtonLoader = ({
  loading,
  className,
  children,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(InnerLoader, {
    loading: loading
  }, /*#__PURE__*/React.createElement(PrimaryButton, _extends({
    className: className
  }, rest), children));
};

const SecondaryButtonLoader = ({
  loading,
  children,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(InnerLoader, {
    loading: loading
  }, /*#__PURE__*/React.createElement(SecondaryButton, rest, children));
};

const SemiTransparentButton = props => {
  const classes = {
    root: styles$l.semitransparent
  };
  return /*#__PURE__*/React.createElement(Button, _extends({
    variant: "contained"
  }, props, {
    classes: classes
  }), props.children);
};

const NoStylesButton = ({
  extraClasses,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement("button", _extends({
    className: `${styles$l.emptyButton} ${extraClasses}`
  }, rest), rest.children);
};

const IconButtonLoader = ({
  loading,
  children,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(InnerLoader, {
    loading: loading
  }, /*#__PURE__*/React.createElement(IconButton$1, rest, children));
};

/**
 * A submit button created to be used inside the Form component
 */

const FormSubmitButton = ({
  label,
  className,
  lang,
  ...rest
}) => {
  useLanguage(lang);
  const {
    t,
    ready
  } = useTranslation(['components']);
  const defaultLabel = ready ? t('components:submit') : '';
  const {
    isSubmitting,
    isDisabled
  } = useFormContext();
  return /*#__PURE__*/React.createElement(PrimaryButtonLoader, _extends({
    loading: isSubmitting,
    disabled: isDisabled || isSubmitting,
    type: "submit",
    className: className,
    title: label || defaultLabel,
    "aria-label": label || defaultLabel
  }, rest), label || defaultLabel);
};

FormSubmitButton.propTypes = {
  /**
   * Overwrites default button label
   */
  label: PropTypes.string,

  /**
   * Sets the button's className
   */
  className: PropTypes.string,

  /**
   * Sets the button's text language for default labels 'en' or 'el'
   */
  lang: PropTypes.string
};

const NewPasswordInput = ({
  control,
  errors,
  name = 'newPassword',
  label,
  autoComplete = 'on',
  maxLength = 24,
  minLength = 8,
  lang,
  ...rest
}) => {
  var _errors$name;

  useLanguage(lang);
  const {
    t,
    ready
  } = useTranslation(['components']);
  const baseName = 'components:errors';
  const [showPassword, setShowPassword] = React.useState(false);
  if (!ready) return null;
  const inputRef = { ...(control === null || control === void 0 ? void 0 : control.register(name, {
      required: {
        value: true,
        message: t(`${baseName}.required`)
      },
      minLength: {
        value: 8,
        message: t(`${baseName}.minLengthNumber`, {
          min: minLength
        })
      },
      maxLength: {
        value: 24,
        message: t(`${baseName}.maxLengthNumber`, {
          max: maxLength
        })
      },
      validate: value => validateOrShowMultipleErrors(value, [{
        validateFunction: validateHasAtLeastOneSymbol,
        errorMessage: t(`${baseName}.confirm-password-rules.1`)
      }, {
        validateFunction: validateDoesNotContainSpecialSymbols,
        errorMessage: t(`${baseName}.confirm-password-rules.2`)
      }])
    }))
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StandardInput, _extends({
    inputRef: inputRef,
    label: label,
    type: showPassword ? 'text' : 'password',
    errorMessage: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
    error: !!errors[name],
    autoComplete: autoComplete,
    endAdornment: /*#__PURE__*/React.createElement(PasswordEndAdornment, {
      showPassword: showPassword,
      setShowPassword: setShowPassword
    })
  }, rest)));
};

NewPasswordInput.propTypes = {
  /**
   * Used to pass the control object that contains methods for registering components into React Hook Form.
   */
  control: PropTypes.object,

  /**
   * A property that provides the React Hook Form errors object to retrieve errors
   */
  errors: PropTypes.object,

  /**
   * A property used to set the input element's name
   */
  name: PropTypes.string,

  /**
   * Sets the input's label text
   */
  label: PropTypes.string,

  /**
   * 	This prop helps users to fill forms faster, especially on mobile devices. The name can be confusing, as it's more like an autofill. You can learn more about it following the specification. https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: PropTypes.string,

  /**
   * A property to set the max length of the input's characters
   */
  maxLength: PropTypes.number,

  /**
   * A property to set the min length of the input's characters
   */
  minLength: PropTypes.number,

  /**
   * Sets the default language of the error messages
   */
  lang: PropTypes.string
};

const ConfirmPasswordInput = ({
  control,
  errors,
  name = 'confirmPassword',
  comparedInputName,
  label,
  lang,
  ...rest
}) => {
  var _errors$name;

  useLanguage(lang);
  const {
    watch
  } = useFormContext();
  const {
    t,
    ready
  } = useTranslation(['components']);
  const [showPassword, setShowPassword] = React.useState(false);
  const baseName = 'components:errors';
  if (!ready) return null;
  const inputRef = { ...(control === null || control === void 0 ? void 0 : control.register(name, {
      required: {
        value: true,
        message: t(`${baseName}.required`)
      },
      validate: value => validateOrShowError(value, value => value === watch(comparedInputName), t(`${baseName}.confirm-password`))
    }))
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StandardInput, _extends({
    inputRef: inputRef,
    label: label,
    type: showPassword ? 'text' : 'password',
    errorMessage: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
    error: !!errors[name],
    endAdornment: /*#__PURE__*/React.createElement(PasswordEndAdornment, {
      showPassword: showPassword,
      setShowPassword: setShowPassword
    })
  }, rest)));
};

ConfirmPasswordInput.propTypes = {
  /**
   * Used to pass the control object that contains methods for registering components into React Hook Form.
   */
  control: PropTypes.object,

  /**
   * A property that provides the React Hook Form errors object to retrieve errors
   */
  errors: PropTypes.object,

  /**
   * A property used to set the input element's name
   */
  name: PropTypes.string,

  /**
   * A property to set the name of the first password input, for its typed password to be confirmed on the current input
   */
  comparedInputName: PropTypes.string.isRequired,

  /**
   * Sets the input's label text
   */
  label: PropTypes.string.isRequired,

  /**
   * Sets the default language of the error messages
   */
  lang: PropTypes.string
};

const LimitedTextInput = ({
  errors = {},
  label,
  required = true,
  name = 'text',
  maxLength = 500,
  minLength = 0,
  defaultValue,
  control,
  lang,
  ...rest
}) => {
  var _errors$name, _errors$name2, _errors$name3;

  useLanguage(lang);
  const {
    t,
    ready
  } = useTranslation(['components']);
  const baseName = 'components:errors';
  const value = useWatch({
    control,
    name: name,
    defaultValue: defaultValue
  });
  const inputRef = { ...control.register(name, {
      required: {
        value: required,
        message: ready ? t(`${baseName}.required`) : ''
      },
      maxLength: {
        value: maxLength,
        message: ready ? t(`${baseName}.maxLengthNumber`, {
          max: maxLength
        }) : ''
      },
      minLength: {
        value: minLength,
        message: ready ? t(`${baseName}.minLengthNumber`, {
          min: minLength
        }) : ''
      }
    })
  };
  return /*#__PURE__*/React.createElement(StandardInput, _extends({
    inputRef: inputRef,
    label: label,
    type: "text",
    errorMessage: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
    error: !!errors[name],
    helperText: (_errors$name2 = errors[name]) !== null && _errors$name2 !== void 0 && _errors$name2.message ? (_errors$name3 = errors[name]) === null || _errors$name3 === void 0 ? void 0 : _errors$name3.message : `${value ? value.length : 0}/${maxLength}`,
    multiline: true
  }, rest));
};

LimitedTextInput.propTypes = {
  /**
   * A property that provides the React Hook Form errors object to retrieve errors
   */
  errors: PropTypes.object,

  /**
   * Sets the input's label text
   */
  label: PropTypes.string,

  /**
   * 	Sets if the input should be required for the submission of the form
   */
  required: PropTypes.bool,

  /**
   * A property used to set the input element's name
   */
  name: PropTypes.string,

  /**
   * Sets the default language of the error messages
   */
  lang: PropTypes.string,

  /**
   * A property to set the max length of the input's characters
   */
  maxLength: PropTypes.number,

  /**
   * A property to set the min length of the input's characters
   */
  minLength: PropTypes.number,

  /**
   * A property used to set the input's default value
   */
  defaultValue: PropTypes.string,

  /**
   * Used to pass the control object that contains methods for registering components into React Hook Form.
   */
  control: PropTypes.object
};

const SelectFormControl = ({
  children,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(FormControl, rest, children);
};

const SelectLabel = ({
  props,
  children
}) => {
  return /*#__PURE__*/React.createElement(InputLabel, _extends({}, props, {
    style: {
      marginLeft: '-1rem'
    }
  }), children);
};

const modalUnderSelectInputProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  }
};
const menuProps = { ...modalUnderSelectInputProps
};
const StandardSelect = /*#__PURE__*/React.forwardRef(({
  defaultValue,
  children,
  MenuProps = menuProps,
  ...rest
}, ref) => {
  return /*#__PURE__*/React.createElement(Select, _extends({
    MenuProps: MenuProps
  }, rest, {
    defaultValue: defaultValue,
    variant: "standard",
    fullWidth: true
  }), children);
});

var styles$k = {"menuItem":"StandardSelectOption-module_menuItem_Y4nKd"};

const StandardSelectOption = /*#__PURE__*/React.forwardRef(({
  children,
  menuItemClass,
  ...props
}, ref) => {
  return /*#__PURE__*/React.createElement(MenuItem, _extends({
    ref: ref,
    className: menuItemClass ? menuItemClass : styles$k.menuItem
  }, props), children);
});

var styles$j = {"MuiFormControlRoot":"SelectInput-module_MuiFormControlRoot_ROft6"};

const SelectInput = ({
  control,
  errors,
  defaultValue = '',
  name,
  label,
  options,
  lang,
  ...rest
}) => {
  useLanguage(lang);
  const {
    t,
    ready
  } = useTranslation(['components']);
  return /*#__PURE__*/React.createElement(SelectFormControl, _extends({}, rest, {
    classes: {
      root: styles$j.MuiFormControlRoot
    }
  }), /*#__PURE__*/React.createElement(SelectLabel, null, label), /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: name,
    defaultValue: defaultValue,
    rules: {
      required: {
        value: true,
        message: ready ? t('components:errors.required') : ''
      }
    },
    render: ({
      field: {
        value,
        name,
        ref,
        onBlur,
        onChange
      }
    }) => /*#__PURE__*/React.createElement(StandardSelect, {
      defaultValue: defaultValue,
      onBlur: onBlur,
      onChange: onChange,
      name: name,
      inputRef: ref,
      label: label,
      "aria-label": label,
      value: value || defaultValue || ''
    }, options.map((option, index) => {
      return /*#__PURE__*/React.createElement(StandardSelectOption, {
        key: index,
        value: option.value
      }, option.label);
    }))
  }), !!errors[name] && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors[name].message));
};

SelectInput.propTypes = {
  /**
   * Used to pass the control object that contains methods for registering components into React Hook Form.
   */
  control: PropTypes.object,

  /**
   * A property that provides the React Hook Form errors object to retrieve errors
   */
  errors: PropTypes.object,

  /**
   * A property used to set the input's default value
   */
  defaultValue: PropTypes.string,

  /**
   * A property used to set the input element's name
   */
  name: PropTypes.string,

  /**
   * Sets the input's label text
   */
  label: PropTypes.string,

  /**
   * A property used to pass the element's options
   */
  options: PropTypes.array,

  /**
   * Sets the default language of the error messages
   */
  lang: PropTypes.string
};

const numberPattern$1 = /^[0-9]*$/;

const NumberInput$1 = ({
  control,
  errors,
  label,
  maxLength = 1000,
  minLength = 0,
  min,
  max,
  name = 'text',
  isRequired = true,
  lang,
  ...rest
}) => {
  var _getValueFromObject;

  useLanguage(lang);
  const {
    t,
    ready
  } = useTranslation(['components']);
  const baseName = 'components:errors';
  const inputRef = { ...control.register(name, {
      required: {
        value: isRequired,
        message: ready ? t(`${baseName}.required`) : ''
      },
      maxLength: {
        value: maxLength,
        message: ready ? t(`${baseName}.maxLengthNumber`, {
          max: maxLength
        }) : ''
      },
      minLength: {
        value: minLength,
        message: ready ? t(`${baseName}.minLengthNumber`, {
          min: minLength
        }) : ''
      },
      min: {
        value: min ? min : undefined,
        message: ready && min ? t(`${baseName}.minNumber`, {
          min: min
        }) : ''
      },
      max: {
        value: max ? max : undefined,
        message: ready && max ? t(`${baseName}.maxNumber`, {
          max: max
        }) : ''
      },
      pattern: {
        value: numberPattern$1,
        message: ready ? t(`${baseName}.isNotNumber`) : ''
      }
    })
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StandardInput, _extends({
    inputRef: inputRef,
    label: label,
    type: "number",
    errorMessage: (_getValueFromObject = getValueFromObject(errors, name)) === null || _getValueFromObject === void 0 ? void 0 : _getValueFromObject.message,
    error: !!getValueFromObject(errors, name)
  }, rest)));
};

NumberInput$1.propTypes = {
  /**
   * Used to pass the control object that contains methods for registering components into React Hook Form.
   */
  control: PropTypes.object,

  /**
   * A property that provides the React Hook Form errors object to retrieve errors
   */
  errors: PropTypes.object,

  /**
   * Sets the input's label text
   */
  label: PropTypes.string,

  /**
   * A property to set the input's min number allowed
   */
  min: PropTypes.number,

  /**
   * A property to set the input's max number allowed
   */
  max: PropTypes.number,

  /**
   * A property to set the max length of the number's digits
   */
  maxLength: PropTypes.number,

  /**
   * A property to set the min length of the number's digits
   */
  minLength: PropTypes.number,

  /**
   * A property used to set the input element's name
   */
  name: PropTypes.string,

  /**
   * Sets the default language of the error messages
   */
  lang: PropTypes.string,

  /**
   * 	Sets if the input should be required for the submission of the form
   */
  isRequired: PropTypes.bool
};

var styles$i = {"MuiAutoCompleteRoot":"AutocompleteInput-module_MuiAutoCompleteRoot_2eCd4","MuiListboxComponent":"AutocompleteInput-module_MuiListboxComponent_2Bonj"};

const AutocompleteInput = ({
  control,
  errors,
  options,
  defaultValue,
  name,
  label,
  requiredErrorMessage,
  multiple,
  lang,
  ...rest
}) => {
  useLanguage(lang);
  const {
    t,
    ready
  } = useTranslation(['components']);

  const getValue = value => {
    if (multiple && value) return options.filter(option => value.includes(option.value));
    return options.filter(option => option.value === value)[0];
  };

  const noValue = multiple ? [] : null;
  return /*#__PURE__*/React.createElement(Controller, {
    name: name,
    control: control,
    rules: {
      required: {
        value: true,
        message: requiredErrorMessage ? requiredErrorMessage : t('components:errors.required')
      }
    },
    defaultValue: getValue(defaultValue),
    render: ({
      field
    }) => /*#__PURE__*/React.createElement(Autocomplete, {
      classes: {
        root: styles$i.MuiAutoCompleteRoot,
        listbox: styles$i.MuiListboxComponent
      },
      multiple: multiple,
      defaultValue: getValue(defaultValue),
      value: getValue(field === null || field === void 0 ? void 0 : field.value) || getValue(defaultValue) || noValue,
      options: options,
      getOptionLabel: option => option.label,
      onChange: (event, data) => {
        if (multiple) {
          return field.onChange(data.map(d => d.value));
        } else {
          return field.onChange(data === null || data === void 0 ? void 0 : data.value);
        }
      },
      onClose: () => defaultValue = noValue,
      renderInput: params => /*#__PURE__*/React.createElement(TextField$1, _extends({}, params, {
        variant: "standard",
        fullWidth: true,
        label: label,
        name: name,
        error: !!errors[name],
        helperText: !!errors[name] && (requiredErrorMessage ? requiredErrorMessage : ready ? t('components:errors.required') : '')
      }, rest))
    })
  });
};

AutocompleteInput.propTypes = {
  /**
   * Used to pass the control object that contains methods for registering components into React Hook Form
   */
  control: PropTypes.object,

  /**
   * A property that provides the React Hook Form errors object to retrieve errors
   */
  errors: PropTypes.object,

  /**
   * A property used to pass the element's options
   */
  options: PropTypes.array,

  /**
   * A property used to set the input's default value
   */
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * A property used to set the input element's name
   */
  name: PropTypes.string,

  /**
   * Sets the input's label text
   */
  label: PropTypes.string,

  /**
   * A property to set a specific error message, ignoring the one provided from the errors object of react-hook-forms
   */
  requiredErrorMessage: PropTypes.string,

  /**
   * A property that allows autocomplete to take more than one value
   */
  multiple: PropTypes.bool,

  /**
   * Sets the default language of the error messages
   */
  lang: PropTypes.string
};
//'601a7add739bb100158b0839'
//defaultValue={getValue(defaultValue)}
//value={[getValue(field?.value)] || noValue}

var styles$h = {"container":"IconText-module_container_1BGoo","iconContainer":"IconText-module_iconContainer_3fscP"};

/**
 * An icon text element that displays them aligned
 */

const IconText = ({
  icon,
  text,
  className,
  iconClass,
  textClass
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles$h.container} ${className}`
  }, /*#__PURE__*/React.createElement("div", {
    className: `${styles$h.iconContainer} ${iconClass}`,
    title: text,
    "aria-label": text
  }, icon), /*#__PURE__*/React.createElement("span", {
    className: textClass
  }, text));
};

IconText.propTypes = {
  /**
   * The icon
   */
  icon: PropTypes.node,

  /**
   * The text
   */
  text: PropTypes.string,

  /**
   * Sets container's className
   */
  className: PropTypes.string,

  /**
   * Sets icon className
   */
  iconClass: PropTypes.string,

  /**
   * Sets text's className
   */
  textClass: PropTypes.string
};

var styles$g = {"span":"UploadImageInput-module_span_1pwti","fileNameSpan":"UploadImageInput-module_fileNameSpan_1obB8"};

const UploadImageInput = ({
  control,
  name,
  label,
  noImageText,
  errors,
  lang
}) => {
  useLanguage(lang);
  const {
    t,
    ready
  } = useTranslation(['components']);
  const noImage = ready ? t('components:errors.noImage') : '';
  const noImageMessage = noImageText ? noImageText : noImage;
  const [fileName, setFileName] = useState(noImageMessage);

  const onChange = event => {
    var _event$target, _event$target$files, _event$target$files$;

    setFileName((event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : (_event$target$files = _event$target.files) === null || _event$target$files === void 0 ? void 0 : (_event$target$files$ = _event$target$files[0]) === null || _event$target$files$ === void 0 ? void 0 : _event$target$files$.name) || noImageMessage);
  };

  const {
    onChange: onInputChange,
    ...registerProps
  } = { ...control.register(name, {
      required: true
    })
  };
  return /*#__PURE__*/React.createElement("span", {
    className: styles$g.span
  }, /*#__PURE__*/React.createElement(PrimaryButton, {
    variant: "contained",
    component: "label"
  }, /*#__PURE__*/React.createElement(IconText, {
    icon: /*#__PURE__*/React.createElement(InsertPhotoIcon, null),
    text: label
  }), /*#__PURE__*/React.createElement("input", _extends({
    hidden: true,
    name: name,
    type: "file",
    accept: "image/*",
    onChange: event => {
      onInputChange(event);
      onChange(event);
    }
  }, registerProps))), /*#__PURE__*/React.createElement("span", {
    className: styles$g.fileNameSpan,
    style: {
      color: errors[name] ? '#f44336' : ''
    }
  }, fileName));
};

UploadImageInput.propTypes = {
  /**
   * Used to pass the control object that contains methods for registering components into React Hook Form.
   */
  control: PropTypes.object,

  /**
   * A property used to set the input element's name
   */
  name: PropTypes.string,

  /**
   * A property used to set the button's text
   */
  label: PropTypes.string,

  /**
   * Sets the default text that should appear if the input has no image
   */
  noImageText: PropTypes.string,

  /**
   * A property that provides the React Hook Form errors object to retrieve errors
   */
  errors: PropTypes.object,

  /**
   * A property that provides the language for the error messages
   */
  lang: PropTypes.string
};

var styles$f = {"picker":"DateTimeInput-module_picker_2GEzy","MuiDialog":"DateTimeInput-module_MuiDialog_2SHNq","input":"DateTimeInput-module_input_HtrDZ"};

dayjs.extend(utc);
dayjs.extend(tz);

const DateTimeInput = ({
  control,
  actions,
  errors,
  defaultValue,
  name,
  label,
  disablePast = true,
  disableFuture = false,
  minDate,
  maxDate,
  format = 'DD/MM/YYYY HH:mm',
  mask = '__/__/____ __:__',
  ampm = false,
  isRequired = true,
  timeZone = 'Europe/Athens',
  lang,
  inputClass = styles$f.input
}) => {
  useLanguage(lang);
  const {
    t,
    ready
  } = useTranslation(['components']);
  const baseName = 'components:errors';
  const {
    setValue,
    trigger
  } = actions;

  const handleDateChange = date => {
    if (!dayjs(date === null || date === void 0 ? void 0 : date.$d).isValid()) return;
    const formattedDate = dayjs(date === null || date === void 0 ? void 0 : date.$d).format('YYYY-MM-DD HH:mm');
    const lockedToTzDate = dayjs.tz(formattedDate, timeZone).toISOString();
    setValue(name, lockedToTzDate);
    trigger(name);
  };

  const isoToTz = date => dayjs(date).tz(timeZone);

  return /*#__PURE__*/React.createElement(Controller, {
    control: control,
    rules: {
      required: {
        value: isRequired,
        message: ready ? t(`${baseName}.required`) : ''
      },
      validate: value => {
        let answer;

        if (minDate) {
          answer = validateOrShowError(value, value => dayjs(minDate).isBefore(value), t(`${baseName}.minDate`, {
            date: dayjs(minDate).tz(timeZone).format('DD/MM/YYYY HH:mm')
          }));
        }

        if (typeof answer === 'string') return answer;

        if (maxDate) {
          answer = validateOrShowError(value, value => dayjs(maxDate).isAfter(value), t(`${baseName}.maxDate`, {
            date: dayjs(maxDate).tz(timeZone).format('DD/MM/YYYY HH:mm')
          }));
        }

        return answer;
      }
    },
    error: !!errors[name],
    name: name,
    setValue: setValue,
    render: ({
      field,
      fieldState
    }) => /*#__PURE__*/React.createElement(LocalizationProvider, {
      dateAdapter: AdapterDayjs
    }, /*#__PURE__*/React.createElement(DateTimePicker, {
      className: styles$f.picker,
      ampm: ampm,
      ampmInClock: ampm,
      name: name,
      label: label,
      disablePast: disablePast,
      disableFuture: disableFuture,
      minDateTime: minDate ? dayjs(minDate) : null,
      maxDateTime: maxDate ? dayjs(maxDate) : null,
      value: field !== null && field !== void 0 && field.value ? isoToTz(field === null || field === void 0 ? void 0 : field.value) : dayjs(defaultValue),
      onChange: handleDateChange,
      mask: mask,
      inputFormat: format,
      renderInput: params => {
        var _fieldState$error;

        return /*#__PURE__*/React.createElement(TextField$1, _extends({}, params, {
          variant: "standard",
          fullWidth: true,
          label: label,
          name: name,
          error: fieldState === null || fieldState === void 0 ? void 0 : fieldState.error,
          helperText: fieldState === null || fieldState === void 0 ? void 0 : (_fieldState$error = fieldState.error) === null || _fieldState$error === void 0 ? void 0 : _fieldState$error.message,
          className: inputClass
        }));
      }
    }))
  });
};

DateTimeInput.propTypes = {
  /**
   * Used to pass the control object that contains methods for registering components into React Hook Form.
   */
  control: PropTypes.object,

  /**
   * A property provided exported functions of a react-hook-form instance
   */
  actions: PropTypes.object,

  /**
   * A property that provides the React Hook Form errors object to retrieve errors
   */
  errors: PropTypes.object,

  /**
   * A property used to set the input's default value
   */
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * A property used to set the input element's name
   */
  name: PropTypes.string,

  /**
   * Sets the input's label text
   */
  label: PropTypes.string,

  /**
   * Disable past dates
   */
  disablePast: PropTypes.bool,

  /**
   * Disable future dates
   */
  disableFuture: PropTypes.bool,

  /**
   * Min selectable date
   */
  minDate: PropTypes.any,

  /**
   * Max selectable date
   */
  maxDate: PropTypes.any,

  /**
   * Format string
   */
  format: PropTypes.string,

  /**
   * 12h/24h view for hour selection clock
   */
  ampm: PropTypes.bool,

  /**
   * Sets if the input should be required for the submission of the form
   */
  isRequired: PropTypes.bool,

  /**
   * A property to set the DateTimeInput's timezone
   */
  timeZone: PropTypes.string,

  /**
   * Sets the default language of the error messages
   */
  lang: PropTypes.string,

  /**
   * A property to set the Datepicker's textfield input className
   */
  inputClass: PropTypes.string
};

const numberPattern = /^[0-9]*$/;

const NumberInput = ({
  control,
  errors,
  label,
  maxLength = 1000,
  minLength = 0,
  name = 'text',
  isRequired = true,
  currency = '€',
  lang,
  ...rest
}) => {
  var _errors$name;

  useLanguage(lang);
  const {
    t,
    ready
  } = useTranslation(['components']);
  const baseName = 'components:errors';
  const inputRef = { ...control.register(name, {
      required: {
        value: isRequired,
        message: ready ? t(`${baseName}.required`) : ''
      },
      maxLength: {
        value: maxLength,
        message: ready ? t(`${baseName}.maxLengthNumber`, {
          max: maxLength
        }) : ''
      },
      minLength: {
        value: minLength,
        message: ready ? t(`${baseName}.minLengthNumber`, {
          min: minLength
        }) : ''
      },
      pattern: {
        value: numberPattern,
        message: ready ? t(`${baseName}.isNotNumber`) : ''
      }
    })
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StandardInput, _extends({
    inputRef: inputRef,
    label: label,
    type: "number",
    errorMessage: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
    error: !!errors[name],
    endAdornment: /*#__PURE__*/React.createElement(InputAdornment$1, {
      position: "end"
    }, currency)
  }, rest)));
};

NumberInput.propTypes = {
  /**
   * Used to pass the control object that contains methods for registering components into React Hook Form.
   */
  control: PropTypes.object,

  /**
   * A property that provides the React Hook Form errors object to retrieve errors
   */
  errors: PropTypes.object,

  /**
   * Sets the input's label text
   */
  label: PropTypes.string,

  /**
   * A property to set the max length of the input's digits
   */
  maxLength: PropTypes.number,

  /**
   * A property to set the min length of the input's digits
   */
  minLength: PropTypes.number,

  /**
   * A property used to set the input element's name
   */
  name: PropTypes.string,

  /**
   * Sets the default language of the error messages
   */
  lang: PropTypes.string,

  /**
   * 	Sets if the input should be required for the submission of the form
   */
  isRequired: PropTypes.bool
};

const EmailInputWithTranslation = props => {
  return /*#__PURE__*/React.createElement(TranslationProvider, null, /*#__PURE__*/React.createElement(EmailInput, props));
};

const PasswordInputWithTranslation = props => {
  return /*#__PURE__*/React.createElement(TranslationProvider, null, /*#__PURE__*/React.createElement(PasswordInput, props));
};

const FormSubmitButtonWithTranslation = props => {
  return /*#__PURE__*/React.createElement(TranslationProvider, null, /*#__PURE__*/React.createElement(FormSubmitButton, props));
};

const NewPasswordInputWithTranslation = props => {
  return /*#__PURE__*/React.createElement(TranslationProvider, null, /*#__PURE__*/React.createElement(NewPasswordInput, props));
};

const ConfirmPasswordInputWithTranslation = props => {
  return /*#__PURE__*/React.createElement(TranslationProvider, null, /*#__PURE__*/React.createElement(ConfirmPasswordInput, props));
};

const LimitedTextInputWithTranslation = props => {
  return /*#__PURE__*/React.createElement(TranslationProvider, null, /*#__PURE__*/React.createElement(LimitedTextInput, props));
};

const SelectInputWithTranslation = props => {
  return /*#__PURE__*/React.createElement(TranslationProvider, null, /*#__PURE__*/React.createElement(SelectInput, props));
};

const NumberInputWithTranslation = props => {
  return /*#__PURE__*/React.createElement(TranslationProvider, null, /*#__PURE__*/React.createElement(NumberInput$1, props));
};

const AutocompleteInputWithTranslation = props => {
  return /*#__PURE__*/React.createElement(TranslationProvider, null, /*#__PURE__*/React.createElement(AutocompleteInput, props));
};

const UploadImageInputWithTranslation = props => {
  return /*#__PURE__*/React.createElement(TranslationProvider, null, /*#__PURE__*/React.createElement(UploadImageInput, props));
};

const DateTimeInputWithTranslation = props => {
  return /*#__PURE__*/React.createElement(TranslationProvider, null, /*#__PURE__*/React.createElement(DateTimeInput, props));
};

const MonetaryInputWithTranslation = props => {
  return /*#__PURE__*/React.createElement(TranslationProvider, null, /*#__PURE__*/React.createElement(NumberInput, props));
};

const colors = {
  darkBlue: '#36495E',
  darkBlueFaded: 'rgb(54, 73, 94, 0.9)',
  lightGray: '#f0f0f0;',
  black: '#303436',
  white: 'white',
  green: '#2db993',
  orange: '#f7ab3f',
  cyan: '#02bbf0',
  grayDisabled: 'rgba(0, 0, 0, 0.38)',
  error: '#f44336'
};
const MuiButtonBaseProperties = {
  borderRadius: '0.25rem',
  fontWeight: '700',
  lineHeight: '1.25rem',
  minHeight: '2.5rem'
};
const theme = createTheme({
  palette: {
    primary: {
      main: colors.darkBlue
    }
  },
  typography: {
    fontFamily: `'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
    'Helvetica Neue', 'sans-serif';`,
    button: {
      fontSize: '1rem',
      textTransform: 'none'
    }
  },
  components: {
    MuiPaper: {
      root: {
        backgroundColor: colors.white
      },
      elevation1: {
        boxShadow: 0
      },
      rounded: {
        borderRadius: '10px'
      }
    },
    MuiSelect: {
      icon: {
        color: 'transparent',
        right: '0.5rem'
      },
      select: {
        '&:focus': {
          backgroundColor: 'transparent'
        }
      }
    },
    MuiList: {
      padding: {
        paddingTop: 0,
        paddingBottom: 0
      },
      root: {
        background: colors.darkBlue
      }
    },
    MuiListItemIcon: {
      root: {
        color: colors.white,
        '& svg': {
          color: colors.white
        }
      }
    },
    MuiMenuItem: {
      root: {
        paddingTop: '1rem',
        paddingBottom: '1rem',
        color: colors.white,
        background: colors.darkBlue,
        lineHeight: '1.25rem',
        minHeight: '2.5rem',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
        paddingRight: '1rem'
      }
    },
    MuiButton: {
      root: {
        '&&:hover': {
          backgroundColor: colors.darkBlue,
          color: colors.white
        },
        '& svg': {
          color: colors.white
        }
      },
      contained: {
        color: colors.white,
        ...MuiButtonBaseProperties,
        backgroundColor: colors.darkBlue,
        '&$disabled': {
          color: colors.white,
          backgroundColor: colors.darkBlue,
          opacity: 0.5
        }
      },
      outlined: {
        color: colors.darkBlue,
        ...MuiButtonBaseProperties,
        border: `0.0625rem solid ${colors.darkBlue}`,
        '&$disabled': {
          color: colors.darkBlue,
          border: `0.0625rem solid ${colors.darkBlue}`,
          opacity: 0.5
        }
      }
    },
    MuiInputLabel: {
      root: {
        color: colors.darkBlue,
        '&$focused': {
          color: colors.darkBlue
        },
        '&$disabled': {
          color: colors.grayDisabled,
          '&$shrink': {
            color: colors.grayDisabled
          },
          '&$focused': {
            color: colors.grayDisabled
          }
        }
      }
    },
    MuiIconButton: {
      root: {
        padding: 0
      }
    },
    MuiSvgIcon: {
      root: {
        backgroundColor: 'transparent'
      }
    },
    MuiFormHelperText: {
      root: {
        color: colors.darkBlue,
        paddingLeft: '0.5rem',
        fontSize: '0.875rem',
        lineHeight: '1.125rem'
      }
    },
    MuiTabs: {
      indicator: {
        height: '0.125rem'
      }
    },
    MuiTab: {
      root: {
        '&$selected': {
          fontWeight: '700'
        }
      }
    },
    MuiBackdrop: {
      root: {
        backgroundColor: colors.darkBlueFaded
      }
    },
    MuiDialog: {
      paper: {
        boxShadow: 'none',
        background: colors.white,
        color: colors.darkBlue,
        borderRadius: '1rem'
      },
      paperWidthFalse: {
        maxWidth: '(100%-1rem)',
        margin: '1rem'
      }
    },
    MuiDialogContent: {
      root: {
        overflowY: 'none',
        '&:first-of-type': {
          paddingTop: 0
        },
        padding: 0
      }
    },
    MuiDialogActions: {
      root: {
        padding: 0
      }
    },
    MuiDialogTitle: {
      root: {
        padding: 0
      }
    },
    MuiButtonBase: {
      root: {
        paddingLeft: 0,
        paddingRight: 0
      }
    },
    MuiInput: {
      input: {
        '&:-webkit-autofill': {
          WebkitTextFillColor: colors.darkBlue,
          WebkitBackgroundClip: 'text',
          caretColor: colors.darkBlue
        },
        fontWeight: '700'
      },
      root: {
        color: colors.darkBlue,
        '&$disabled': {
          color: colors.grayDisabled,
          '&$focused': {
            color: colors.grayDisabled
          },
          '&:hover': {
            color: colors.grayDisabled
          }
        }
      },
      underline: {
        '&:before': {
          borderBottom: `0.0625rem solid ${colors.darkBlue}`
        },
        '&:after': {
          borderBottom: `0.125rem solid ${colors.darkBlue}`
        },
        '&&:hover:before': {
          borderBottom: `0.0625rem solid ${colors.darkBlue}`
        },
        '&$disabled': {
          '&&:before': {
            borderBottom: `0.0625rem solid ${colors.grayDisabled}`
          }
        }
      }
    },
    MuiDataGrid: {
      root: {
        border: `1px solid ${colors.white}`,
        borderRadius: '1rem',
        padding: '1rem',
        backgroundColor: colors.white,
        color: colors.darkBlue
      }
    },
    MuiSwitch: {
      switchBase: {
        checked: {
          color: '#16ABA7'
        }
      }
    }
  },
  props: {
    MuiTab: {
      disableRipple: true
    }
  }
});

const WaveThemeProvider = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(StylesProvider, {
    injectFirst: true
  }, /*#__PURE__*/React.createElement(StyledEngineProvider, {
    injectFirst: true
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, children)));
};

/**
 * A wrapper component for inputs to be used if there is need for an extra level between Form and inputs. The container passes down the control object, the form errors object, the inputs defaultValue (depends on inputs name), the inputs current value (depends on inputs name), an actions object with the setValue and trigger functions.
 */

const FormInputsContainer = ({
  defaultValues,
  children,
  ...rest
}) => {
  const {
    errors,
    control,
    getValues,
    setValue,
    trigger
  } = useFormContext();
  const inputs = Children.map(children, child => {
    var _child$props, _child$props2;

    if (!child) return;

    if (typeof (child === null || child === void 0 ? void 0 : child.type) === 'string') {
      return child;
    }

    return /*#__PURE__*/cloneElement(child, {
      control,
      errors,
      defaultValue: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues[child === null || child === void 0 ? void 0 : (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.name]) || null,
      current: getValues(child === null || child === void 0 ? void 0 : (_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.name),
      actions: {
        setValue,
        trigger
      },
      ...rest
    });
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, inputs);
};

FormInputsContainer.propTypes = {
  /**
   * The default form's values for the inputs that are passed as children to the FormInputsContainer element
   */
  defaultValues: PropTypes.object,

  /**
   * The inputs
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

/**
 * A component configured to function as part of the Form component, completing the form's structure by containing the form's inputs inside a form tag
 */

const FormContainer = ({
  className,
  children,
  ...rest
}) => {
  const {
    onSubmit
  } = useFormContext();
  return /*#__PURE__*/React.createElement("form", _extends({
    noValidate: true,
    className: className
  }, rest, {
    onSubmit: onSubmit
  }), children);
};

FormContainer.propTypes = {
  /**
   * Sets the element's className
   */
  className: PropTypes.string,

  /**
   * Sets the element's children
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

/**
 * A form component that provides its children with Form Context.
 */

const Form = ({
  onSubmit,
  className,
  children,
  defaultValues,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(FormContextProvider, {
    submitCallback: onSubmit,
    defaultValues: defaultValues
  }, /*#__PURE__*/React.createElement(FormContainer, _extends({
    className: className
  }, rest), /*#__PURE__*/React.createElement(FormInputsContainer, null, children)));
};

Form.propTypes = {
  /**
   * Sets the onSubmit callback
   */
  onSubmit: PropTypes.func.isRequired,

  /**
   * Sets the className of the forms container
   */
  className: PropTypes.string,

  /**
   * Sets the form's content
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),

  /**
   * An object with the default values of the form's inputs
   */
  defaultValues: PropTypes.object
};

var styles$e = {"container":"FormErrorBoxMessageError-module_container_3r-IV"};

/**
 * A component that is part of the FormErrorBox component
 */

const FormErrorBoxMessageError = ({
  errorMessage,
  errorTitle,
  defaultErrorMessage,
  lang
}) => {
  useLanguage(lang);
  const {
    t,
    ready
  } = useTranslation(['components']);
  const title = errorTitle ? errorTitle : ready ? t('components:errors.genericTitle') : '';
  const body = errorMessage ? errorMessage : defaultErrorMessage ? defaultErrorMessage : ready ? t('components:errors.genericMessage') : '';
  return /*#__PURE__*/React.createElement("div", {
    className: styles$e.container
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, title)), /*#__PURE__*/React.createElement("p", null, body));
};

FormErrorBoxMessageError.propTypes = {
  /**
   * Sets the error's message description
   */
  errorMessage: PropTypes.string,

  /**
   * Sets the error's message title
   */
  errorTitle: PropTypes.string,

  /**
   * Sets the error's default message description
   */
  defaultErrorMessage: PropTypes.string,

  /**
   * Sets the language of the error's generic (default-fallback) title and description text
   */
  lang: PropTypes.string
};

/**
 * A form error message component that uses the context of the Form component to show up when form has error. Screen scroll's it in display if needed.
 */

const FormErrorBox = ({
  className,
  lang,
  defaultErrorMessage,
  ...rest
}) => {
  const {
    hasError,
    resetState,
    errorMessage,
    errorTitle
  } = useFormContext();
  return /*#__PURE__*/React.createElement(ErrorBox, _extends({
    showError: hasError,
    onClose: resetState,
    className: className
  }, rest), /*#__PURE__*/React.createElement(TranslationProvider, null, /*#__PURE__*/React.createElement(FormErrorBoxMessageError, {
    errorMessage: errorMessage,
    errorTitle: errorTitle,
    defaultErrorMessage: defaultErrorMessage,
    lang: lang
  })));
};

FormErrorBox.propTypes = {
  /**
   * Sets the component's className
   */
  className: PropTypes.string,

  /**
   * Sets the default messages language
   */
  lang: PropTypes.string,

  /**
   * Overwrites the default error message for the component
   */
  defaultErrorMessage: PropTypes.string
};

function SuccessIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-testid": "SuccessIcon",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#0DB916",
    cx: 10,
    cy: 10,
    r: 9.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.329 8.773a.923.923 0 011.305 0l1.733 1.733 5.223-5.22a.923.923 0 011.305 0l1.081 1.08c.36.36.36.945 0 1.306l-5.863 5.863a.627.627 0 01-.011.011l-1.305 1.305a.923.923 0 01-1.306 0l-3.467-3.467a.923.923 0 010-1.306l1.305-1.305z",
    fill: "#FFF"
  })));
}

const ErrorIcon = props => {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.25 .25)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FF5800",
    cx: "9.731",
    cy: "9.731",
    r: "9.731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.17 14.17a.955.955 0 0 1-1.337 0l-3.103-3.1-3.102 3.102a.955.955 0 0 1-1.338 0 .955.955 0 0 1 0-1.338L8.393 9.73 5.291 6.629a.955.955 0 0 1 0-1.338.955.955 0 0 1 1.338 0l3.102 3.102 3.102-3.102a.955.955 0 0 1 1.338 0 .955.955 0 0 1 0 1.338l-3.102 3.102 3.102 3.102a.955.955 0 0 1 0 1.338z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
};

const AvatarIcon = props => {
  return /*#__PURE__*/React.createElement("svg", {
    width: "32",
    height: "33",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "16",
    fill: "#E1E1DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.567 17.97a6.545 6.545 0 0 0 2.881-5.44C22.448 8.925 19.561 6 16 6c-3.561 0-6.448 2.924-6.448 6.53a6.545 6.545 0 0 0 2.882 5.44C8.278 19.238 5.042 22.654 4 26.952c.17.208.347.41.527.609.043.048.089.095.133.142.139.149.28.296.423.44l.181.174a15.766 15.766 0 0 0 1.023.904c.073.06.147.118.22.176.141.11.284.217.429.321.074.054.148.109.224.162.152.106.307.209.464.31.07.045.139.092.21.137.18.112.364.22.55.326.049.027.096.057.146.084.24.133.483.26.73.38l.018.009c.236.114.476.223.718.325.075.032.152.06.228.09.175.072.35.141.529.205.094.035.19.066.285.098a13.917 13.917 0 0 0 1.285.376 16.08 16.08 0 0 0 .817.176c.11.02.22.042.332.06.17.028.339.051.51.074.107.014.214.03.322.04.188.022.377.036.567.05.092.006.183.016.275.021a14.824 14.824 0 0 0 1.708.001c.092-.005.184-.015.275-.021.19-.014.38-.028.567-.049.108-.012.215-.027.323-.041.17-.023.34-.046.509-.074.11-.018.222-.039.332-.06a14.312 14.312 0 0 0 1.297-.302l.315-.09c.165-.05.328-.105.49-.16.095-.032.191-.063.285-.098.178-.064.354-.133.529-.204l.228-.091c.241-.102.48-.21.714-.324l.022-.01c.247-.12.49-.247.73-.38.05-.027.097-.057.146-.085.186-.106.37-.213.55-.326.071-.044.14-.09.21-.137.157-.1.312-.204.464-.31.076-.053.15-.107.224-.161a16.64 16.64 0 0 0 .65-.497 15.497 15.497 0 0 0 1.022-.904c.06-.058.121-.116.18-.175.145-.144.286-.29.424-.44.044-.047.09-.094.133-.142.18-.198.357-.4.526-.608H28c-1.041-4.299-4.277-7.715-8.433-8.983z",
    fill: "#ADAEB1"
  })));
};

var styles$d = {"box":"FormSuccessBox-module_box_3Im3h","icon":"FormSuccessBox-module_icon_25f6F"};

/**
 * A form success message component that uses the context of the Form component to show up when form submits successfully.
 */

const FormSuccessBox = ({
  children,
  className,
  iconClassName,
  ...rest
}) => {
  const {
    showSuccess
  } = useFormContext();
  return /*#__PURE__*/React.createElement(MessageBox, _extends({
    className: `${styles$d.box} ${className}`,
    show: showSuccess
  }, rest), /*#__PURE__*/React.createElement(SuccessIcon, {
    className: `${styles$d.icon} ${iconClassName}`
  }), children);
};

FormSuccessBox.propTypes = {
  /**
   * Sets the components children elements
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),

  /**
   * Sets the component's additional className
   */
  className: PropTypes.string,

  /**
   * Sets the component's icon className
   *
   */
  iconClassName: PropTypes.string
};

var styles$c = {"wrapper":"PageLoader-module_wrapper_14FZT"};

/**
 * A page loader component
 */

const PageLoader = ({
  className,
  size = 64,
  thickness = 5,
  backgroundColor,
  loaderColor = '#ffffff',
  disableShrink = true,
  fullPage = true
}) => {
  const style = {
    backgroundColor
  };

  if (fullPage) {
    style.position = 'fixed';
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles$c.wrapper,
    style: style
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CircularProgress, {
    className: className,
    style: {
      color: loaderColor
    },
    variant: "indeterminate",
    disableShrink: disableShrink,
    size: size,
    thickness: thickness
  })));
};

PageLoader.propTypes = {
  /**
   * Pass a string of classes on the loaders's container
   */
  className: PropTypes.string,

  /**
   * Sets loaders's diameter
   */
  size: PropTypes.number,

  /**
   * Sets the loader's thickness
   */
  thickness: PropTypes.number,

  /**
   * Sets the background color of the loaders's container
   */
  backgroundColor: PropTypes.string,

  /**
   * Sets the color of the loader
   */
  loaderColor: PropTypes.string,

  /**
   * Chooses the loader's shrink status
   */
  disableShrink: PropTypes.bool,

  /**
   * Sets the loader full page
   */
  fullPage: PropTypes.bool
};

/**
 * Conditional content returns its content only if a condition is met. Else it returns null.
 */

const ConditionalContent = ({
  showOn,
  children
}) => {
  if (!showOn) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

ConditionalContent.propTypes = {
  /**
   * The condition
   */
  showOn: PropTypes.bool,

  /**
   * The context
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

var styles$b = {"dialogTitle":"Dialog-module_dialogTitle_1BWgQ","header":"Dialog-module_header_Qkmgt","dialogContent":"Dialog-module_dialogContent_1Fmh-","dialogActions":"Dialog-module_dialogActions_12HkJ","backButton":"Dialog-module_backButton_3z0rn","iconButton":"Dialog-module_iconButton_67t8C","dialog":"Dialog-module_dialog_1tRWI","container":"Dialog-module_container_2vcu7"};

/**
 * A general dialog component.
 */

const Dialog = ({
  open = true,
  onClose,
  children,
  dialogActions,
  dialogHeader,
  dialogClassName = '',
  dialogTitleClassName = '',
  dialogHeaderClassName = '',
  dialogContentClassName = '',
  dialogActionsClassName = '',
  iconButtonClassName = styles$b.iconButton,
  showCloseButton = true,
  scroll = 'body',
  showBackButton = false,
  onBack = () => {},
  disabledBackdropClick = false
}) => {
  const dialogClasses = {
    paper: `${styles$b['dialog']} ${dialogClassName}`,
    container: `${styles$b['container']}`
  };
  /**
   * Fix the issue that show the Dialog's center if Dialog is bigger than the screen instead of its top
   */

  const [scrollMethod, setScrollMethod] = useState('paper');
  useEffect(() => {
    const scrollTimeout = setTimeout(() => {
      setScrollMethod(scroll);
    });
    return () => {
      clearTimeout(scrollTimeout);
    };
  }, [scroll]);

  const handleClose = (event, reason) => {
    if (disabledBackdropClick || reason !== 'backdropClick') {
      onClose(event, reason);
    }
  };

  return /*#__PURE__*/React.createElement(Dialog$1, {
    open: open,
    onClose: handleClose,
    classes: dialogClasses,
    scroll: scrollMethod
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    className: `${styles$b.dialogTitle} ${dialogTitleClassName}`
  }, /*#__PURE__*/React.createElement(ConditionalContent, {
    showOn: Boolean(showBackButton)
  }, /*#__PURE__*/React.createElement(IconButton$1, {
    className: styles$b.backButton,
    "aria-label": "back",
    onClick: onBack,
    size: "large"
  }, /*#__PURE__*/React.createElement(ArrowBackIcon, null))), /*#__PURE__*/React.createElement("span", {
    className: `${styles$b.header} ${dialogHeaderClassName}`
  }, dialogHeader), /*#__PURE__*/React.createElement(ConditionalContent, {
    showOn: Boolean(showCloseButton)
  }, /*#__PURE__*/React.createElement(IconButton$1, {
    className: iconButtonClassName,
    "aria-label": "close",
    onClick: onClose,
    size: "large"
  }, /*#__PURE__*/React.createElement(CloseIcon, null)))), /*#__PURE__*/React.createElement(DialogContent, {
    className: `${styles$b.dialogContent} ${dialogContentClassName}`
  }, children), /*#__PURE__*/React.createElement(ConditionalContent, {
    showOn: Boolean(dialogActions)
  }, /*#__PURE__*/React.createElement(DialogActions, {
    className: `${styles$b.dialogActions} ${dialogActionsClassName}`
  }, dialogActions)));
};

Dialog.propTypes = {
  /**
   * Controls the dialog's visibility
   */
  open: PropTypes.bool,

  /**
   * Pass the callback that is triggered when the close icon is clicked
   */
  onClose: PropTypes.func,

  /**
   * Dialog's content
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),

  /**
   * Pass buttons or other actions for the dialog
   */
  dialogActions: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),

  /**
   * Pass dialog's title
   */
  dialogHeader: PropTypes.string,

  /**
   * Pass a string of classes on the material UI's paper container
   */
  dialogClassName: PropTypes.string,

  /**
   * Pass a string of classes on for the dialog's title
   */
  dialogTitleClassName: PropTypes.string,

  /**
   * Pass a string of classes to the dialog's header
   */
  dialogHeaderClassName: PropTypes.string,

  /**
   * Pass a string of classes on the dialog's content
   */
  dialogContentClassName: PropTypes.string,

  /**
   * Pass a string of classes on the dialog's actions
   */
  dialogActionsClassName: PropTypes.string,

  /**
   * Pass a specific string of classes on the dialogs "close" button
   */
  iconButtonClassName: PropTypes.string,

  /**
   * Sets the close button visibility
   */
  showCloseButton: PropTypes.bool,

  /**
   * Sets the dialog's scroll behavior. 'body': no scroll inside dialog, 'paper': scoll inside dialog
   */
  scroll: PropTypes.string,

  /**
   * Sets the back button visibility
   */
  showBackButton: PropTypes.bool,

  /**
   * Sets a callback triggered when back button is chosen
   */
  onBack: PropTypes.func
};

var styles$a = {"message":"TableMessage-module_message_F6eGz"};

const TableErrorMessage = () => {
  const {
    t,
    ready
  } = useTranslation(['components']);
  const message = ready ? t(`components:errors.genericMessage`) : '';
  return /*#__PURE__*/React.createElement("h2", {
    className: styles$a.message
  }, message);
};

const TableErrorMessageWithTranslation = () => {
  return /*#__PURE__*/React.createElement(TranslationProvider, null, /*#__PURE__*/React.createElement(TableErrorMessage, null));
};

const TableNoRowsMessage = () => {
  const {
    t,
    ready
  } = useTranslation(['components']);
  const message = ready ? t(`components:errors.noRows`) : '';
  return /*#__PURE__*/React.createElement("h2", {
    className: styles$a.message
  }, message);
};

const TableNoRowsMessageWithTranslation = () => {
  return /*#__PURE__*/React.createElement(TranslationProvider, null, /*#__PURE__*/React.createElement(TableNoRowsMessage, null));
};

var styles$9 = {"tableLoaderContainer":"TableLoadingOverlay-module_tableLoaderContainer_2YPfJ"};

const TableLoadingOverlay = () => {
  const darkBlue = colors.darkBlue;
  const size = 128;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$9.tableLoaderContainer
  }, /*#__PURE__*/React.createElement(InnerLoader, {
    loading: true,
    size: size,
    color: darkBlue
  }));
};

const Table = ({
  loading,
  rows,
  columns,
  error,
  loadingOverlay,
  errorOverlay,
  noRowsOverlay,
  lang,
  ...rest
}) => {
  useLanguage(lang);
  errorOverlay = errorOverlay ? errorOverlay : TableErrorMessageWithTranslation;
  noRowsOverlay = noRowsOverlay ? noRowsOverlay : TableNoRowsMessageWithTranslation;
  const overlay = error ? errorOverlay : noRowsOverlay;
  const components = {
    LoadingOverlay: loadingOverlay ? loadingOverlay : TableLoadingOverlay,
    NoRowsOverlay: overlay,
    Toolbar: GridToolbar
  };

  if (rest !== null && rest !== void 0 && rest.components) {
    rest.components = { ...components,
      ...rest.components
    };
  } else {
    rest.components = { ...components
    };
  }

  const {
    t,
    ready
  } = useTranslation(['components']);
  const labels = ready ? t(`components:gridLabels`, {
    returnObjects: true
  }) : '';
  const localeText = lang === 'en' ? null : { ...elGR.components.MuiDataGrid.defaultProps.localeText,
    toolbarFilters: ready ? labels.toolbarFilters : '',
    toolbarDensity: ready ? labels.toolbarDensity : '',
    toolbarDensityCompact: ready ? labels.toolbarDensityCompact : '',
    toolbarDensityStandard: ready ? labels.toolbarDensityStandard : '',
    toolbarDensityComfortable: ready ? labels.toolbarDensityComfortable : ''
  };
  return /*#__PURE__*/React.createElement(DataGrid, _extends({
    loading: loading,
    rows: rows,
    columns: columns,
    columnBuffer: 5,
    disableSelectionOnClick: true,
    disableColumnMenu: true,
    localeText: localeText
  }, rest));
};

Table.propTypes = {
  /**
   * Sets the loader visibility
   */
  loading: PropTypes.bool,

  /**
   * Sets the rows
   */
  rows: PropTypes.array,

  /**
   * Sets the columns and their preferences
   */
  columns: PropTypes.array,

  /**
   * Sets the error overlay visibility
   */
  error: PropTypes.any,

  /**
   * Overwrite default loader
   */
  loadingOverlay: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),

  /**
   * Overwrite default error overlay
   */
  errorOverlay: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),

  /**
   * Overwrite default no rows overlay
   */
  noRowsOverlay: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),

  /**
   * Sets the language 'en' or 'el'
   */
  lang: PropTypes.string
};

var styles$8 = {"disclaimer":"Disclaimer-module_disclaimer_2YyQx"};

/**
 * Disclaimer component for small text
 */

const Disclaimer = ({
  children
}) => {
  return /*#__PURE__*/React.createElement("small", {
    className: styles$8.disclaimer
  }, children);
};

Disclaimer.propTypes = {
  /**
   * Disclaimer content
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

var styles$7 = {"container":"ColumnsContainer-module_container_2eLxf"};

/**
 * Columns container is a flexbox row container
 */

const ColumnsContainer = ({
  className,
  children,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement("div", _extends({
    className: `${styles$7.container} ${className}`
  }, rest), children);
};

ColumnsContainer.propTypes = {
  /**
   * Sets the containers className for extra styling
   */
  className: PropTypes.string,

  /**
   * Property to add children elements to the element
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

var styles$6 = {"figure":"AvatarInitials-module_figure_smiLI","span":"AvatarInitials-module_span_2HePJ"};

/**
 * An avatar component used to display the first letter of a user's name and last name
 */

const AvatarInitials = ({
  name,
  lastName,
  backgroundColor = '#ffffff',
  color = '#36495e'
}) => {
  return /*#__PURE__*/React.createElement("figure", {
    className: styles$6.figure,
    style: {
      backgroundColor,
      color
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$6.span
  }, `${name && name[0] ? name[0] : ''}${lastName && lastName[0] ? lastName[0] : ''}`));
};

AvatarInitials.propTypes = {
  /**
   * The user's name
   */
  name: PropTypes.string,

  /**
   * The user's last name
   */
  lastName: PropTypes.string,

  /**
   * Avatar's background color
   */
  backgroundColor: PropTypes.string,

  /**
   *Initials color
   */
  color: PropTypes.string
};

const TextInput = ({
  control,
  errors = {},
  label,
  required = true,
  name = 'text',
  errorMessage,
  requiredErrorMessage,
  lang,
  ...rest
}) => {
  var _errors$name;

  useLanguage(lang);
  const {
    t,
    ready
  } = useTranslation(['components']);
  const baseName = 'components:errors';
  const inputRef = control !== null && control !== void 0 && control.register ? { ...control.register(name, {
      required: {
        value: required,
        message: requiredErrorMessage ? requiredErrorMessage : ready ? t(`${baseName}.required`) : ''
      }
    })
  } : {};
  return /*#__PURE__*/React.createElement(StandardInput, _extends({
    inputRef: inputRef,
    label: label,
    type: "text",
    errorMessage: errorMessage ? errorMessage : (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
    error: !!errors[name]
  }, rest));
};

TextInput.propTypes = {
  /**
   * Used to pass the control object that contains methods for registering components into React Hook Form.
   */
  control: PropTypes.object,

  /**
   * A property that provides the React Hook Form errors object to retrieve errors
   */
  errors: PropTypes.object,

  /**
   * Sets the input's label text
   */
  label: PropTypes.string,

  /**
   * 	Sets if the input should be required for the submission of the form
   */
  required: PropTypes.bool,

  /**
   * A property used to set the input element's name
   */
  name: PropTypes.string,

  /**
   * Sets a specific error message for the input, if it is null, the message from the errors object of react-hook-form appears
   */
  errorMessage: PropTypes.string,

  /**
   * Sets the default language of the error messages
   */
  lang: PropTypes.string
};

var styles$5 = {"container":"NumberArrayInput-module_container_30J2x","row":"NumberArrayInput-module_row_1RVz3","input":"NumberArrayInput-module_input_u1Nhg","button":"NumberArrayInput-module_button_26vU4","addButton":"NumberArrayInput-module_addButton_3wDxZ"};

const NumberArrayInput = ({
  name,
  label,
  valueKey,
  control,
  errors,
  watch,
  labelAdd,
  labelRemove,
  actions,
  current,
  min = 0,
  ...rest
}) => {
  const {
    fields,
    append,
    remove
  } = useFieldArray({
    control,
    name: name
  });
  const watchFieldArray = watch(name);
  const controlledFields = fields.map((field, index) => {
    return { ...field,
      ...watchFieldArray[index]
    };
  });
  return /*#__PURE__*/React.createElement("section", {
    className: styles$5.container
  }, controlledFields.map((field, index) => /*#__PURE__*/React.createElement("div", {
    key: field.id,
    className: styles$5.row
  }, /*#__PURE__*/React.createElement(NumberInput$1, _extends({
    control: control,
    label: `${label} ${index}`,
    name: `${name}.${index}.${valueKey}`,
    className: styles$5.input,
    min: index === 0 ? min : Number(watch(`${name}.${index - 1}.${valueKey}`)) + 1,
    errors: errors
  }, rest)), /*#__PURE__*/React.createElement(IconButtonLoader, {
    type: "button",
    title: labelRemove,
    "aria-label": labelRemove,
    onClick: () => remove(index),
    className: styles$5.button,
    loading: false
  }, /*#__PURE__*/React.createElement(DeleteIcon, null)))), /*#__PURE__*/React.createElement(SecondaryButton, {
    name: "add ",
    onClick: () => append({
      [valueKey]: ''
    }),
    className: styles$5.addButton
  }, labelAdd));
};

NumberArrayInput.propTypes = {
  /**
   * A property used to set the input element's name
   */
  name: PropTypes.string,

  /**
   * Sets the input's label text
   */
  label: PropTypes.string,

  /**
   * Sets label for button that adds new input
   */
  labelAdd: PropTypes.string,

  /**
   * Sets label for delete button
   */
  labelRemove: PropTypes.string,

  /**
   * Key used to read object's property inside values array. eg for [{level:1}, {level:2}] valueKey will be 'level'
   */
  valueKey: PropTypes.string,

  /**
   * Used to pass the control object that contains methods for registering components into React Hook Form.
   */
  control: PropTypes.object,

  /**
   * Used to watch field used in React Hook Form.
   */
  watch: PropTypes.func.isRequired,

  /**
   * A property to set the input's min number allowed
   */
  min: PropTypes.number
};

const TableBody = ({
  children,
  ...rest
}) => /*#__PURE__*/React.createElement(TableBodyMaterial, rest, children);

TableBody.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

const TableHead = ({
  children,
  ...rest
}) => /*#__PURE__*/React.createElement(TableHeadMaterial, rest, children);

TableHead.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

/**
 * A building block element for the Dense Table that creates a row and has table cells as children.
 */

const TableRow = ({
  children,
  ...rest
}) => /*#__PURE__*/React.createElement(TableRowMaterial, rest, children);

TableRow.propTypes = {
  /**
   * Sets the TableCell elements
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

var styles$4 = {"MuiTableCellRoot":"TableCell-module_MuiTableCellRoot_2meSN","MuiTableCellRootHeader":"TableCell-module_MuiTableCellRootHeader_2qL7y"};

/**
 * A building block element for the Dense Table
 */

const TableCell = ({
  children,
  ...rest
}) => /*#__PURE__*/React.createElement(TableCellMaterial, _extends({
  classes: {
    root: styles$4.MuiTableCellRoot
  }
}, rest), children);

const TableCellHeader = ({
  children,
  ...rest
}) => /*#__PURE__*/React.createElement(TableCellMaterial, _extends({
  classes: {
    root: styles$4.MuiTableCellRootHeader
  }
}, rest), children);

TableCell.propTypes = {
  /**
   * Sets the table's cell content
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

/**
 * A small table component. Use TableRow & TableCell components as children for content.
 */

const DenseTable = ({
  headerTitles,
  className,
  children
}) => {
  return /*#__PURE__*/React.createElement(TableContainer, {
    className: className
  }, /*#__PURE__*/React.createElement(Table$1, {
    size: "small",
    "aria-label": "a dense table"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, headerTitles.map(title => /*#__PURE__*/React.createElement(TableCellHeader, {
    key: title
  }, title)))), /*#__PURE__*/React.createElement(TableBody, null, children)));
};

DenseTable.propTypes = {
  /**
   * Sets the table's container className
   */
  className: PropTypes.string,

  /**
   * An array of column headers
   */
  headerTitles: PropTypes.array,

  /**
   * Set the table rows and cells
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

var styles$3 = {"button":"WidgetButton-module_button_3N0hj"};

/**
 * A button matching the style of a widget element
 */

const WidgetButton = ({
  backgroundColor,
  padding = '1rem',
  label,
  onClick,
  children
}) => {
  return /*#__PURE__*/React.createElement(Widget, {
    backgroundColor: backgroundColor,
    padding: "0"
  }, /*#__PURE__*/React.createElement("button", {
    className: styles$3.button,
    style: {
      padding
    },
    onClick: onClick,
    type: "button",
    label: label,
    "aria-label": label
  }, children));
};

WidgetButton.propTypes = {
  /**
   * Sets the background color of the button's widget component container
   */
  backgroundColor: PropTypes.string,

  /**
   * Sets the padding of the button element
   */
  padding: PropTypes.string,

  /**
   * Sets button's label
   */
  label: PropTypes.string,

  /**
   * Sets the onClick callback
   */
  onClick: PropTypes.func,

  /**
   * The button content
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

var styles$2 = {"container":"InfoMessageBox-module_container_2l3yX","textContainer":"InfoMessageBox-module_textContainer_3dJxd","icon":"InfoMessageBox-module_icon_8F0Cp"};

/**
 * A box element for displaying information to the user.
 */

const InfoMessageBox = ({
  show = true,
  className,
  color = '#ffffff',
  backgroundColor = '#36495e',
  padding = '1rem',
  title,
  body,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(MessageBox, _extends({
    show: show,
    className: className,
    backgroundColor: backgroundColor,
    padding: padding
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: styles$2.container,
    style: {
      color
    }
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    className: `${styles$2.icon}`,
    style: {
      color
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: `${styles$2.textContainer}`
  }, /*#__PURE__*/React.createElement("strong", null, title), body)));
};

InfoMessageBox.propTypes = {
  /**
   * Controls wether the box element is visible
   */
  show: PropTypes.bool,

  /**
   * Pass a string of classes applied on the element's section container
   */
  className: PropTypes.string,

  /**
   * Sets the box element's background color
   */
  backgroundColor: PropTypes.string,

  /**
   * Sets the content's color
   */
  color: PropTypes.string.isRequired,

  /**
   * Sets the padding of the box element
   */
  padding: PropTypes.string,

  /**
   * The text displayed inside the element
   */
  title: PropTypes.string,

  /**
   * This property can be used to pass chidlren under the title
   */
  body: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

var styles$1 = {"button":"VerticalMenu-module_button_2LIDn","menu":"VerticalMenu-module_menu_3Z13B"};

/**
 * A pop-up menu element
 */

const VerticalMenu = ({
  items,
  color = 'white',
  backgroundColor,
  className,
  label = 'simple',
  children
}) => {
  const [anchorElement, setAnchorElement] = useState(null);
  const open = Boolean(anchorElement);

  const onClick = event => {
    setAnchorElement(event.currentTarget);
  };

  const onClose = () => {
    setAnchorElement(null);
  };

  if (!label) label = 'simple';
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(Button, {
    className: styles$1.button,
    "aria-owns": anchorElement ? `${label}-menu` : undefined,
    "aria-haspopup": "true",
    "aria-label": label,
    "aria-expanded": open ? 'true' : undefined,
    onClick: onClick,
    style: {
      padding: '0',
      color,
      backgroundColor
    },
    endIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
      style: {
        color
      }
    }),
    disableRipple: true
  }, children), /*#__PURE__*/React.createElement(Menu, {
    className: styles$1.menu,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    id: `${label}-menu`,
    anchorEl: anchorElement,
    open: open,
    onClose: onClose
  }, items.map((item, index) => /*#__PURE__*/React.createElement(MenuItem, {
    key: index,
    onClick: onClose
  }, item))));
};

VerticalMenu.propTypes = {
  /**
   * An array of the menu items
   */
  items: PropTypes.array,

  /**
   * Sets menu's arrow button color
   */
  color: PropTypes.string,

  /**
   * Sets the menu's button background color
   */
  backgroundColor: PropTypes.string,

  /**
   * Sets the className of the menu's container
   */
  className: PropTypes.string,

  /**
   * Set's menu's arrow button label
   */
  label: PropTypes.string,

  /**
   * Sets the menu's button content
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

/**
 * Switch component with label.
 */

const Toggle = ({
  checked,
  onChange,
  labelPlacement = 'end',
  label,
  className
}) => {
  const WaveSwitch = styled(Switch)(() => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: '#16ABA7',
      '&:hover': {
        backgroundColor: '#9CD5D3'
      }
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: '#16ABA7'
    }
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    label: label,
    labelPlacement: labelPlacement,
    control: /*#__PURE__*/React.createElement(WaveSwitch, {
      checked: checked,
      onClick: onChange,
      label: label,
      style: {
        marginLeft: 'auto'
      }
    })
  }));
};

Toggle.propTypes = {
  /**
   * Sets the switch's status
   */
  checked: PropTypes.bool,

  /**
   * A callback triggered with switch's click
   */
  onChange: PropTypes.func,

  /**
   * Set's the label's place 'end','start',top' or 'bottom'
   */
  labelPlacement: PropTypes.string,

  /**
   * Sets the label
   */
  label: PropTypes.string,

  /**
   * Sets switch's container class name
   */
  className: PropTypes.string
};

var styles = {"container":"SwitchInput-module_container_SmWXS"};

const SwitchInput = ({
  control,
  name,
  label,
  defaultValue
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("p", null, label), /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: name,
    defaultValue: defaultValue === null || undefined ? false : defaultValue,
    render: ({
      field: {
        value,
        name,
        ref,
        onBlur,
        onChange
      }
    }) => /*#__PURE__*/React.createElement(Toggle, {
      checked: value,
      onChange: onChange,
      label: '',
      labelPlacement: "start"
    })
  }));
};

SwitchInput.propTypes = {
  /**
   * A property used to set the input element's name
   */
  name: PropTypes.string,

  /**
   * Sets the input's label text
   */
  label: PropTypes.string,

  /**
   * A property to provide the switch input's default value
   */
  defaultValue: PropTypes.bool
};

const TableToolbar = ({
  children,
  name
}) => {
  return /*#__PURE__*/React.createElement(GridToolbarContainer, null, /*#__PURE__*/React.createElement(GridToolbarFilterButton, null), /*#__PURE__*/React.createElement(GridToolbarDensitySelector, null), /*#__PURE__*/React.createElement(GridToolbarExport, {
    csvOptions: {
      fileName: name
    }
  }), children);
};

export { AutocompleteInputWithTranslation as AutocompleteInput, AvatarIcon, AvatarInitials, ColumnsContainer, ConditionalContent, ConfirmPasswordInputWithTranslation as ConfirmPasswordInput, DateTimeInputWithTranslation as DateTimeInput, DenseTable, Dialog, Disclaimer, EmailInputWithTranslation as EmailInput, ErrorBox, ErrorIcon, Form, FormErrorBox, FormInputsContainer, FormSubmitButtonWithTranslation as FormSubmitButton, FormSuccessBox, IconButtonLoader, IconText, InfoMessageBox, InnerLoader, LimitedTextInputWithTranslation as LimitedTextInput, VerticalMenu as Menu, MessageBox, MonetaryInputWithTranslation as MonetaryInput, NewPasswordInputWithTranslation as NewPasswordInput, NoStylesButton, NumberArrayInput, NumberInputWithTranslation as NumberInput, PageLoader, PageTitle, PasswordInputWithTranslation as PasswordInput, PrimaryButton, PrimaryButtonLoader, SecondaryButton, SecondaryButtonLoader, SelectInputWithTranslation as SelectInput, SemiTransparentButton, StandardInput, SuccessIcon, Toggle as Switch, SwitchInput, Table, TableCell, TableRow, TableToolbar, TextButton, TextInput, UploadImageInputWithTranslation as UploadImageInput, WaveThemeProvider, Widget, WidgetButton, colors, useFormContext };
